var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"property-select-multiple-colored-tag"},[_c('div',{staticClass:"property-select-multiple-colored-tag__color-indicator",style:({ 'background-color': _vm.color})}),_vm._v(" "),_c('span',{staticClass:"property-select-multiple-colored-tag__label"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }